import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { logEvent } from '~/config/firebase.config';

import { sendOnboardingLink } from './sendOnboardingLink';

export type SendTvLinkState = 'idle' | 'sending' | 'sent' | 'error';

/**
 * « M'envoyer le lien » : magic-link de connexion vers l'email du compte, à
 * ouvrir sur l'ordinateur branché à la TV (même lien que la passerelle /welcome,
 * atterrit sur /link puis /home). `source` préfixe les événements de mesure
 * (`<source>_email_sent` / `<source>_email_error`). `sendFrom(autreSource)` : même
 * état partagé, mesure propre à l'endroit du clic (télécommande : 2 aides, 1 état).
 */
export function useSendTvLink(email: string, clientID: string, source: string) {
    const { i18n } = useTranslation();
    const [state, setState] = useState<SendTvLinkState>('idle');

    const sendFrom = async (from: string) => {
        if (!email || state === 'sending') return;
        setState('sending');
        try {
            await sendOnboardingLink(email, i18n.language, from);
            logEvent(`${from}_email_sent`, clientID, { clientID });
            setState('sent');
        } catch {
            logEvent(`${from}_email_error`, clientID, { clientID });
            setState('error');
        }
    };
    // Sans argument : sûr en `onClick={send}` (l'événement du clic n'est pas une source).
    const send = () => sendFrom(source);

    return { state, send, sendFrom, canSend: !!email };
}
